<template>
  <div class="benefits-list__card">
    <div class="benefits-list__card__icon">
      <img
        :src="require(`@/assets/svg/icons-general-${icon}.svg`)"
        :alt="icon"
      />
    </div>
    <div class="benefits-list__card__text">
      <span>{{ title }}</span>
      <p>{{ description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BenefitsCard',
  props: {
    title: { type: String, required: true },
    description: { type: String, required: true },
    icon: { type: String, required: true }
  }
}
</script>

<style lang="scss" scoped>
.benefits-list__card {
  display: flex;
  width: 100%;

  @media (min-width: 768px) {
    max-width: calc((100% / 3) - 12px);
  }

  &__icon {
    height: 40px;
    margin-right: 18px;
    margin-top: 5px;
    width: 40px;

    img {
      height: 100%;
    }
  }

  &__text {
    span {
      color: #707070;
      font-family: Rubik;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 16.2px;
    }

    p {
      color: #444444;
      font-family: oscine;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 21.6px;
    }
  }
}
</style>
